export const COMPANY = {
  name: "JT Knudsen v/Jonas Knudsen",
  shortName: "JT Knudsen",
  owner: "Jonas Knudsen",
  phone: "42 79 63 01",
  phoneRaw: "42796301",
  phoneHref: "tel:+4542796301",
  email: "jt.knudsen8530@gmail.com",
  address: "8530 Hjortshøj",
  cvr: "",
  serviceAreas: [
    "Hjortshøj",
    "Aarhus",
    "Grenaa",
    "Hornslet",
    "Hinnerup",
    "Egå",
    "Østjylland",
    "Djursland"
  ]
}

export const IMAGES = {
  hero: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/jt-knudsen-minigraver-haveanlaeg-terrasse.jpeg",
  jonas: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/jonas-knudsen-entreprenoer-profil.jpg",
  trampolin: {
    hero: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/nedgravning-af-trampolin-minigraver-have.jpeg",
    work: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/nedgravning-trampolin-udgravning-have.jpg",
    extra: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/nedgravning-trampolin-oval-have.jpg"
  },
  belaegning: {
    hero: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/belaegning-fliser-forhave-murstenshus.jpeg",
    driveway: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/belaegning-indkoersel-havegang.jpg",
    detail: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/belaegning-detalje-flisearbejde.jpg"
  },
  fundament: {
    hero: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/fundament-sokkel-udgravning-cat-gravemaskine.jpeg",
    casting: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/stobt-betonfundament-armeringsjern-forskalling.jpeg"
  },
  gravearbejde: {
    hero: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/gravearbejde-udgravning-jordbund-minigraver.jpeg",
    trench: "https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/gravearbejde-draen-kabelgravning.jpg"
  }
}

export const SERVICES = [
  {
    title: "Belægning",
    shortTitle: "Belægning",
    path: "/belaegning",
    serviceKey: "belaegning",
    galleryKey: "belaegning",
    icon: "fa-solid fa-shapes",
    description: "Terrasser, gangarealer, mindre indkørsler og havestier med fokus på stabilt bærelag, fald og finish.",
    image: IMAGES.belaegning.hero,
    badge: "Populær"
  },
  {
    title: "Fundament & sokkel",
    shortTitle: "Fundament & sokkel",
    path: "/fundament",
    serviceKey: "fundament",
    galleryKey: "fundament-sokkel",
    icon: "fa-solid fa-cubes-stacked",
    description: "Præcis udgravning og forberedelse til tilbygninger, skure, carporte og mindre byggerier.",
    image: IMAGES.fundament.hero,
    badge: "Præcision"
  },
  {
    title: "Gravearbejde",
    shortTitle: "Gravearbejde",
    path: "/gravearbejde",
    serviceKey: "gravearbejde",
    galleryKey: "gravearbejde",
    icon: "fa-solid fa-trowel-bricks",
    description: "Maskingravning, jordflytning, klargøring af haver og byggefelter med moderne og skånsomme maskiner.",
    image: IMAGES.gravearbejde.hero,
    badge: "Moderne maskiner"
  },
  {
    title: "Nedgravning af trampolin",
    shortTitle: "Trampolinnedgravning",
    path: "/nedgravning-af-trampolin",
    serviceKey: "nedgravning-af-trampolin",
    galleryKey: "nedgravning-af-trampolin",
    icon: "fa-solid fa-circle-nodes",
    description: "Professionel udgravning, korrekt dybde, effektiv håndtering af jord og et harmonisk udtryk i haven.",
    image: IMAGES.trampolin.hero,
    badge: "Specialitet"
  }
]

export const NAV_LINKS = [
  { label: "Forside", path: "/" },
  {
    label: "Ydelser",
    path: "/ydelser",
    dropdown: [
      { label: "Oversigt over ydelser", path: "/ydelser" },
      { label: "Belægning", path: "/belaegning" },
      { label: "Fundament & sokkel", path: "/fundament" },
      { label: "Gravearbejde", path: "/gravearbejde" },
      { label: "Nedgravning af trampolin", path: "/nedgravning-af-trampolin" }
    ]
  },
  { label: "Om JT Knudsen", path: "/om-jt-knudsen" },
  { label: "Galleri", path: "/galleri" },
  { label: "Kontakt", path: "/kontakt" }
]

export const HOME_FAQ = [
  {
    question: "Hvad kan anlægsentreprenører hjælpe med?",
    answer: "Anlægsentreprenører kan blandt andet hjælpe med grundarbejde, renovering, tilbygninger og praktiske forbedringer omkring boligen, herunder udgravning, fundamentopbygning, belægning og bortkørsel af jord."
  },
  {
    question: "Hvad skal man være opmærksom på ved nedgravning af trampolin?",
    answer: "Ved nedgravning af trampolin skal der tages højde for trampolinens mål, placering, korrekt dybde, luftcirkulation under dugen, adgangsforhold for maskiner og mulighed for afvanding i bunden af hullet."
  },
  {
    question: "Hvordan etableres et solidt fundament til en tilbygning?",
    answer: "Et solidt fundament skal tilpasses konstruktionens belastning og jordforholdene på stedet. JT Knudsen sørger for præcis afsætning, udgravning i frostfri dybde, stabilt bærelag samt klargøring til armering og støbning."
  },
  {
    question: "Hvad er vigtigt, når der skal lægges belægning?",
    answer: "Ved belægning er en korrekt opbygning med bærelag, afretning og passende fald afgørende for et stabilt og holdbart resultat, så regnvand ledes væk og stenene ikke sætter sig ujævnt over tid."
  },
  {
    question: "Hvordan foregår et bygge- og anlægsarbejde fra start til slut?",
    answer: "Hos JT Knudsen begynder bygge- og anlægsarbejde med en afklaring af opgavens omfang, kundens ønsker og forholdene på grunden. Derefter planlægges arbejdsgangen i den rigtige rækkefølge fra udgravning til færdigt resultat."
  },
  {
    question: "Hvilke oplysninger skal bruges for at få et tilbud på anlægsarbejde?",
    answer: "For at kunne vurdere opgaven har JT Knudsen brug for oplysninger om projektets type og omfang, arealmål, adgangsforhold for maskiner på grunden samt din ønskede tidsramme."
  }
]

export const TRAMPOLIN_FAQ = [
  {
    question: "Hvilke fordele har en nedgravet trampolin?",
    answer: "JT Knudsen hjælper med at integrere trampolinen naturligt i haven. En nedgravet trampolin fylder mindre i udsynet, giver haven et roligere udtryk og giver en lav og nem adgang for børnene."
  },
  {
    question: "Hvad kræver professionel nedgravning af trampolin?",
    answer: "Ved professionel nedgravning af trampolin tilpasser JT Knudsen hullets form og dybde efter den valgte model, sikrer tilstrækkelig luftpassage samt stabil understøtning af rammen."
  },
  {
    question: "Kan en almindelig model bruges som trampolin til nedgravning?",
    answer: "En almindelig fritstående trampolin bør kun graves ned, hvis producenten udtrykkeligt tillader det og leverer anvisning til korrekt luftpassage og rammestøtte. En dedikeret in-ground model anbefales altid."
  },
  {
    question: "Hvordan vælger man den rigtige placering til en nedgravet trampolin?",
    answer: "JT Knudsen anbefaler en jævn placering med den foreskrevne sikkerhedsafstand til træer, hegn, bygninger og faste elementer, samt hensyn til underjordiske kabler og dræn."
  },
  {
    question: "Hvordan foregår trampolin nedgravning fra opmåling til færdig udgravning?",
    answer: "Ved trampolin nedgravning får JT Knudsen først model, mål og ønsker på plads. Derefter afmærkes placeringen, jorden udgraves i den korrekte skålformede dybde, og afslutningen omkring rammen tilpasses."
  },
  {
    question: "Nedgravning af trampolin pris – hvad påvirker tilbuddet?",
    answer: "En nedgravning af trampolin pris afhænger blandt andet af trampolinens størrelse og form, hullets dybde, jordens beskaffenhed (ler, sten, sand), adgangsforhold for maskiner og aftalen om overskudsjord."
  },
  {
    question: "Hvilke oplysninger skal man give for at få et tilbud på nedgravning af trampolin?",
    answer: "For at vurdere opgaven har JT Knudsen brug for trampolinens model og mål, den ønskede placering samt information om haveadgangens bredde og eventuelle trapper."
  }
]

export const FUNDAMENT_FAQ = [
  {
    question: "Hvordan foregår opbygning af fundament?",
    answer: "Hos JT Knudsen begynder opbygning af fundament med afsætning og udgravning i den nødvendige dybde. Derefter klargøres bærelag, isolering, armering og forskalling inden støbning."
  },
  {
    question: "Hvor dybt skal et fundament graves?",
    answer: "Den nødvendige dybde afhænger blandt andet af jordbund, konstruktion, belastning og frostfri dybde (typisk minimum 90 cm i Danmark) samt projektets tekniske specifikationer."
  },
  {
    question: "Hvilken type fundament passer til byggeriet?",
    answer: "Valget afhænger af konstruktionen og de faktiske jordforhold. Randfundament, punktfundament eller en samlet betonplade kan være relevant ud fra projektets krav."
  },
  {
    question: "Hvad er vigtigt ved støbning af fundament?",
    answer: "Ved støbning af fundament skal underlaget være stabilt, og mål, niveauer, forskalling og armering skal kontrolleres omhyggeligt før og under udstøbningen."
  },
  {
    question: "Hvordan mindskes risikoen for sætninger, revner og fugt i et fundament?",
    answer: "Risikoen mindskes ved at tænke jordbund, belastning, dybde, materialer og konstruktion sammen fra starten, sikre korrekt komprimering og fugtspærre."
  },
  {
    question: "Hvordan hænger fundament og sokkel sammen?",
    answer: "Fundamentet overfører byggeriets belastning til jorden, mens soklen danner overgangen mellem jorden og bygningen. Korrekte højder og fugtsikring er afgørende."
  },
  {
    question: "Hvad koster et nyt fundament?",
    answer: "Prisen afhænger blandt andet af fundamentets størrelse, udgravningsdybde, jordbund, adgang for maskiner samt mængden af beton, armering og overskudsjord."
  },
  {
    question: "Kan et fundament tilpasses tilbygninger og renoveringer?",
    answer: "Ja, JT Knudsen udfører fundament opbygning til blandt andet tilbygninger, renoveringer, garager, skure og specialiserede byggeopgaver."
  }
]

export const BELAEGNING_FAQ = [
  {
    question: "Hvad kan belægning i haven bruges til?",
    answer: "Hos JT Knudsen kan belægning bruges til blandt andet terrasser, havestier, indgangspartier, opholdsarealer og mindre indkørsler, der skaber praktiske overgange."
  },
  {
    question: "Hvordan opbygges en stabil have belægning?",
    answer: "JT Knudsen opbygger have belægning ved at grave ud i den nødvendige dybde og etablere et stabilt bærelag af knust beton/stabilgrus, efterfulgt af et afrettet sandlag og fugefyldning."
  },
  {
    question: "Hvilken belægning til terrasse skal man vælge?",
    answer: "Valget af belægning til terrasse afhænger af arealets størrelse, form, anvendelse, møblering og adgangsveje samt husets arkitektur og personlige præferencer."
  },
  {
    question: "Hvorfor er fald og afvanding vigtigt ved belægning?",
    answer: "Et korrekt fald hjælper med at lede regnvand væk fra bygningers sokkel og opholdsarealer, så vandpytter og frostskader undgås."
  },
  {
    question: "Skal man vælge store fliser eller mindre belægningssten?",
    answer: "Store fliser kan skabe et roligt og moderne udtryk, mens mindre belægningssten giver flere muligheder for mønstre, kurver og detaljer omkring bede."
  },
  {
    question: "Hvad skal man overveje ved vedligeholdelse af belægning?",
    answer: "Flisernes overfladestruktur, rengøringsbehov, fugesandets kvalitet og løbende algebehandling bør indgå i valget af sten og fliser."
  },
  {
    question: "Hvad koster ny belægning?",
    answer: "Prisen på ny belægning afhænger blandt andet af arealets størrelse, adgangsforhold, eksisterende underlag, flisetype samt omfanget af udgravning og bortkørsel."
  }
]

export const ALL_GALLERY_ITEMS = [
  {
    id: "g1",
    title: "Nedgravet trampolin i plan med græsplæne",
    category: "Nedgravning af trampolin",
    galleryKey: "nedgravning-af-trampolin",
    image: IMAGES.trampolin.hero,
    caption: "Udgravning og montering af in-ground trampolin i moderne parcelhushave med præcise græskanter."
  },
  {
    id: "g2",
    title: "Udgravningsfase til rund trampolin",
    category: "Nedgravning af trampolin",
    galleryKey: "nedgravning-af-trampolin",
    image: IMAGES.trampolin.work,
    caption: "Præcisionsarbejde med minigraver, bunddræn og skånsom kørsel på udlagte køreplader."
  },
  {
    id: "g3",
    title: "Oval trampolin tilpasset havens linjer",
    category: "Nedgravning af trampolin",
    galleryKey: "nedgravning-af-trampolin",
    image: IMAGES.trampolin.extra,
    caption: "Nedgravning af oval trampolinmodel med god afstand til hæk og terrasse."
  },
  {
    id: "g4",
    title: "Moderne stenterrasse med store fliser",
    category: "Belægning",
    galleryKey: "belaegning",
    image: IMAGES.belaegning.hero,
    caption: "Ny terrasse i lysegrå havefliser med skarpe afslutninger og korrekt fald væk fra huset."
  },
  {
    id: "g5",
    title: "Indkørsel og gangsti i kvalitetssten",
    category: "Belægning",
    galleryKey: "belaegning",
    image: IMAGES.belaegning.driveway,
    caption: "Kombineret indkørsel og gangareal udført med stabilt bærelag til personbilsbelastning."
  },
  {
    id: "g6",
    title: "Detaljearbejde og præcisionsafretning",
    category: "Belægning",
    galleryKey: "belaegning",
    image: IMAGES.belaegning.detail,
    caption: "Fugning, afretning og skæring af kantsten for et ensartet, professionelt resultat."
  },
  {
    id: "g7",
    title: "Udgravning til sokkel og tilbygning",
    category: "Fundament & sokkel",
    galleryKey: "fundament-sokkel",
    image: IMAGES.fundament.hero,
    caption: "Rendegravning i frostfri dybde og klargøring af underlag til støbning af fundament."
  },
  {
    id: "g8",
    title: "Klargjort støbefelt med armering",
    category: "Fundament & sokkel",
    galleryKey: "fundament-sokkel",
    image: IMAGES.fundament.casting,
    caption: "Forskalling, afretning og armering klar til betonstøbning til garage og skur."
  },
  {
    id: "g9",
    title: "Maskingravning og haveplanering",
    category: "Gravearbejde",
    galleryKey: "gravearbejde",
    image: IMAGES.gravearbejde.hero,
    caption: "Minigraver i aktion med jordflytning, afretning og klargøring til haveanlæg."
  },
  {
    id: "g10",
    title: "Kabel- og rendegravning",
    category: "Gravearbejde",
    galleryKey: "gravearbejde",
    image: IMAGES.gravearbejde.trench,
    caption: "Smal rendegravning til forsyningsledninger, drænrør og elinstallationer."
  }
]
